<template>
    <div class="index">
        <!-- <div class="top">
            <el-steps :active="stepsActive" simple finish-status="process" process-status="finish" style="width:500px">
                <el-step title="待接收" :icon="stepsActive>0?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="已接受" :icon="stepsActive>1?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="调查中" :icon="stepsActive>2?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="作业退回" :icon="stepsActive>3?'el-icon-folder-checked':'el-icon-edit'" v-if="detailData.executeAction==25"></el-step>
                <el-step title="完成" :icon="stepsActive>3?'el-icon-folder-checked':'el-icon-edit'" v-else></el-step>
              
                
            </el-steps>
            
        </div> -->
        <!-- <div class="taskreason" v-if="detailData.taskSate==30">
            <span>*</span>
            审核退回原因： 
            {{detailData.taskReason}}
        </div> -->
        <el-tabs type="border-card" @tab-click="changeTab">
            <el-tab-pane label="任务信息">
                <div class="section">
                    <div class="title">
                        基础信息
                    </div>
                    <div class="item">
                        <div class="label">
                            赔案号
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cClmNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>

                    <div class="item">
                        <div class="label">
                            调查任务
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.cDoubtId" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查任务开始时间
                        </div>
                        <div class="value">
                            <el-date-picker
                            v-model="detailData.startTime"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            disabled
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查任务截至时间
                        </div>
                        <div class="value">
                            <el-date-picker
                            v-model="detailData.endTime"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            disabled
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调度人
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.dispatcher" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            作业人
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.operator" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            作业机构
                        </div>
                        <div class="value">
                            <el-input v-model="detailData.operatorMechanism" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查意见
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.cDoubtOpin" placeholder="请输入" size="small" type="textarea" disabled></el-input>
                        </div>
                    </div>
                </div>
                

               
                <div class="section">
                    <div class="title">
                        保险信息
                    </div>
                    <div class="item">
                        <div class="label">
                            保障产品
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cProdName" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            保单号
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cPlyNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            投保时间
                        </div>
                        <el-date-picker
                        v-model="surveyDataInfo.tInsAddTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        disabled
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                    <!-- <div class="item">
                        <div class="label">
                            与成员的关系
                        </div>
                        <div class="value">
                            <el-select v-model="surveyDataInfo.guanxi" size="small" placeholder="请选择" @change="bzProductIdChange" class="citem-input">
                                <el-option
                                v-for="item in relationList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div> -->
                    <div class="item">
                        <div class="label">
                            被保人
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cInsuredNme" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            被保人证件类型
                        </div>
                        <div class="value">
                            <el-select v-model="surveyDataInfo.cCertType" size="small" placeholder="请选择" @change="bzProductIdChange" class="citem-input" disabled>
                                <el-option
                                v-for="item in InsuredNoTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    
                   
                    <div class="item">
                        <div class="label">
                            被保人证件号
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cCertNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                </div>

                <div class="section">
                    <div class="title">
                        出险信息
                    </div>
                    <div class="item">
                        <div class="label">
                            出险时间
                        </div>
                        <div class="value">
                            <el-date-picker
                            v-model="surveyDataInfo.tAccdntTm"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            disabled
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <!-- <div class="item">
                        <div class="label">
                            出险地区
                        </div>
                        <div class="value">
                            <el-cascader
                            size="small"
                            :options="regionData"
                            v-model="surveyDataInfo.cAccdntPlace"
                            @change="handleRegionChange">
                            </el-cascader>
                        </div>
                    </div> -->
                    <div class="item">
                        <div class="label">
                            出险地点
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.cAccdntPlace" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            出险经过
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.cAccdntPro" placeholder="请输入" size="small" type="textarea" disabled></el-input>
                        </div>
                    </div>
                    
                </div>
                <div class="section">
                    <div class="title">
                        报案信息
                    </div>
                    <div class="item">
                        <div class="label">
                            报案人电话
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.cRptTell" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                        </div>
                    </div>
                   
                    <div class="item">
                        <div class="label">
                            报案时间
                        </div>
                        <el-date-picker
                        v-model="surveyDataInfo.tRptTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        disabled
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                   
                </div>
                <div class="section">
                    <div class="title">
                        调查结论
                    </div>
                    <div class="item">
                        <div class="label">
                            调查结论
                        </div>
                        <div class="value">
                            <el-select v-model="surveyDataInfo.cConclusion" size="small" placeholder="请选择">
                                <el-option
                                v-for="item in cConclusionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            调查意见
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.cConcRst" placeholder="请输入" size="small" type="textarea"></el-input>
                        </div>
                    </div>
                    <div class="item" v-if="surveyDataInfo.cConclusion=='3'">
                        <div class="label">
                            拒赔原因
                        </div>
                        <div class="value" style="width:590px">
                            <el-select v-model="surveyDataInfo.cRefuseRsn" size="small" placeholder="请选择">
                                <el-option
                                v-for="item in RefuseRsnList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item" v-if="surveyDataInfo.cConclusion=='3'">
                        <div class="label">
                            拒赔金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.nRefusePayAmt" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </div>
                    <div class="item" v-if="surveyDataInfo.cConclusion=='2'">
                        <div class="label">
                            减损金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.nDeroAmt" placeholder="请输入" size="small" type="number"></el-input>
                        </div>
                    </div>
                    <div class="item" style="width:100%">
                        <el-button type="primary" icon="el-icon-edit" @click="updateCccnn" size="small">确认编辑</el-button>
                    </div>
                </div>
                <div class="section">
                    <div class="title">
                        保司审核信息
                    </div>
                    <div class="item">
                        <div class="label">
                            保司审核状态
                        </div>
                        <div class="value">
                            <el-select v-model="surveyDataInfo.auditResult" size="small" placeholder="请选择" disabled>
                                <el-option
                                v-for="item in auditResultList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    
                    <div class="item">
                        <div class="label">
                            保司不通过原因
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.backReason" placeholder="请输入" size="small" type="textarea" disabled></el-input>
                        </div>
                    </div>
                </div>
                
                <div class="section">
                    <div class="title">
                        结案信息
                    </div>
                    <div class="item">
                        <div class="label">
                            赔付结论
                        </div>
                        <div class="value" style="width:590px">
                            <el-input v-model="surveyDataInfo.claimResultStr" placeholder="请输入" size="small" type="textarea" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            实际赔付金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.actualAmount" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            减损金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.derogationAmount" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">
                            约定赔付金额
                        </div>
                        <div class="value">
                            <el-input v-model="surveyDataInfo.agreedAmount" placeholder="请输入" size="small" disabled></el-input>
                        </div>
                    </div>
                    
                </div>
            </el-tab-pane>
            <el-tab-pane label="调查信息">
                <div style="margin:0 10px;width:100%">
                    <!-- <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="doubtCourseAddTip()">添加调查信息</el-button>
                        </div>
                    </div> -->
                    <el-table
                        :data="surveyData"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                       
                        <el-table-column
                        prop="cSvyNeed"
                        label="调查需求"
                        align="center"
                        width="400">
                        </el-table-column>
                        <el-table-column
                        prop="tHopeEndTm"
                        label="期望完成时间"
                        align="center"
                        width="240">
                        <template slot-scope="scope">
                            <span style="color:red">{{scope.row.tHopeEndTm}}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cSvyType"
                        label="疑似类型"
                        align="center"
                        width="150">
                        </el-table-column>
                        <el-table-column
                        prop="cSvyMode"
                        label="案件类型"
                        align="center"
                        width="120">
                        </el-table-column>
                        <el-table-column
                        prop="cSvyPlace"
                        label="调查地点"
                        align="center"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        prop="cSvyAddr"
                        label="调查地址"
                        align="center"
                        >
                        </el-table-column>
                    
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="100px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="surveyDataDetail(scope.row)">查看详情</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="调查资料">
                <div style="margin:0 10px;width:100%">
                    
                    <!-- <el-table
                    :data="surveyInfo"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width:100%"
                    >
                    <el-table-column
                    type="index"
                    label="序号"
                    width="60"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="materialType"
                    label="资料类型"
                    align="center"
                    width="180"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.materialType==1">图片</span>
                        <span v-if="scope.row.materialType==2">音频</span>
                        <span v-if="scope.row.materialType==3">音视频</span>
                        <span v-if="scope.row.materialType==4">其他</span>
                    </template>

                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="资料名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="180px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-zoom-in" size="small" @click="showImg(scope.row.path)" v-if="scope.row.materialType==1">点击查看</el-button>
                        <el-button type="text" icon="el-icon-download" size="mini" @click="download(scope.row.path,scope.row.name)">下载</el-button>
                    </template>
                    </el-table-column>
                    </el-table> -->
                    <div class="materiallist">
                        <div class="material" v-for="(item,index) in surveyInfo" :key="index">
                            <img src="../../../assets/images/icon11.png" alt="" v-if="item.materialType=='mp3'||item.materialType=='aac'||item.materialType=='wav'||item.materialType=='wma'||item.materialType=='flac'||item.materialType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                            <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.materialType=='rmvb'||item.materialType=='rm'||item.materialType=='ts'||item.materialType=='tp'||item.materialType=='avi'||item.materialType=='3gp'||item.materialType=='mp4'||item.materialType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                            <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.materialType=='xls'||item.materialType=='xlsx'||item.materialType=='doc'||item.materialType=='docx'||item.materialType=='ppt'||item.materialType=='pptx'||item.materialType=='pdf'||item.materialType=='zip'||item.materialType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                            <el-image
                            style="width: 120px; height: 120px"
                            :src="item.path"
                            v-else
                            @click="showImg(item.path,surveyInfo)"
                            :fit="cover"></el-image>
                            <div class="filename">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            
            <el-tab-pane label="调查结果">
                <div class="section">
                    <div class="title">
                        调查过程
                    </div>
                    <div style="margin:0 10px;width:100%">
                        <!-- <div class="handle">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isAddDoubtCourse=true">添加调查信息</el-button>
                            </div>
                        </div> -->
                        <el-table
                            :data="doubtCourseList"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width:100%"
                            >
                            <el-table-column
                            type="index"
                            label="序号"
                            width="60"
                            align="center"
                            >
                            </el-table-column>
                        
                            <el-table-column
                            prop="tCourTm"
                            label="调查时间"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourAddr"
                            label="调查省级市"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourPlace"
                            label="调查地点"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourPlace==1">医院</span>
                                <span v-if="scope.row.cCourPlace==2">事故地</span>
                                <span v-if="scope.row.cCourPlace==3">常住地</span>
                                <span v-if="scope.row.cCourPlace==4">住宅</span>
                                <span v-if="scope.row.cCourPlace==5">就诊地</span>
                                <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cCourPro"
                            label="调查项目"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourPro==1">正面调查</span>
                                <span v-if="scope.row.cCourPro==2">基础调查</span>
                                <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                                <span v-if="scope.row.cCourPro==4">事故查勘</span>
                            </template>
                            </el-table-column>
                            <!-- <el-table-column
                            prop="cCourAddr"
                            label="调查地址"
                            align="center"
                            >
                            </el-table-column> -->
                        
                            <el-table-column
                            prop="cCourMode"
                            label="案件类型"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourMode=='1'">全案</span>
                                <span v-if="scope.row.cCourMode=='2'">单点</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cCourOperNme"
                            label="被调查人姓名"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="cCourRela"
                            label="被调查人与被保人关系"
                            align="center"
                            width="180px"
                            >
                            <template slot-scope="scope">
                                <span v-if="scope.row.cCourRela=='601002'">子女</span>
                                <span v-if="scope.row.cCourRela=='601003'">父母</span>
                                <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                                <span v-if="scope.row.cCourRela=='601005'">本人</span>
                                <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                                <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                                <span v-if="scope.row.cCourRela=='601008'">其它</span>
                                <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                                <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                                <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                                <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                                <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                                <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                                <span v-if="scope.row.cCourRela=='601016'">未知</span>
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="cProcess"
                            label="调查过程"
                            align="center"
                            width="150px"
                            >
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                                <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                            </template>
                            </el-table-column>
                            <el-table-column
                            fixed="right"
                            label="操作"
                            width="150px"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-edit" size="mini" @click="editCCour(scope.row)" >编辑</el-button>
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="section">
                    <div class="title">
                        调查资料
                    </div>
                    <div style="margin:0 10px;width:100%">
                        <!-- <div class="handle">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="isAddCaseMaterial=true">添加资料信息</el-button>
                            </div>
                        </div> -->
                        <div class="section-item" v-for="(mitem,mindex) in materialList" :key="mindex">
                            <div class="stitle">{{mitem[0].name}}</div>
                            <div class="materiallist">
                                <div class="material" v-for="(item,index) in mitem" :key="index">
                                    <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                    <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                    <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                    <el-image
                                    style="width: 120px; height: 120px"
                                    :src="item.path"
                                    v-else
                                    @click="showImg(item.path,mitem)"
                                    :fit="cover"></el-image>
                                    <div class="filename">{{item.fileName}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="作业人员">
                <div style="margin:0 10px;width:100%">
                    <div class="handle" v-if="stepsActive==1||stepsActive==2">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="assignPersonTip">指派人员</el-button>
                        </div>
                    </div>
                    <el-table
                        :data="personTaskList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        width="80"
                        label="序号"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cClmNo"
                        label="赔案号"
                        align="center"
                        width="250px"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cPlyNo"
                        label="保单号"
                        align="center"
                        width="250px"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="operator"
                        label="作业人"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="executeAction"
                        label="任务状态"
                        align="center"
                        >
                        <template slot-scope="scope">
                            {{scope.row.executeAction==0?"待接收":""}}
                            {{scope.row.executeAction==10?"待派工":""}}
                            {{scope.row.executeAction==20?"调查中":""}}
                            {{scope.row.executeAction==21?"已提交":""}}
                            {{scope.row.executeAction==25?"任务退回":""}}
                            {{scope.row.executeAction==30?"完成":""}}
                            
                        </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="240px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="personDetail(scope.row)">查看资料</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="全部作业机构">
                <el-table
                    :data="otherJgList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    type="index"
                    width="80"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="operatorMechanism"
                    label="机构名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="dispatcher"
                    label="调度人"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="executeAction"
                    label="状态"
                    align="center"
                    >
                    <template slot-scope="scope">
                        {{scope.row.executeAction==0?"待接收":""}}
                        {{scope.row.executeAction==10?"待派工":""}}
                        {{scope.row.executeAction==20?"调查中":""}}
                        {{scope.row.executeAction==21?"已提交":""}}
                        {{scope.row.executeAction==25?"任务退回":""}}
                        {{scope.row.executeAction==30?"完成":""}}

                    </template>

                    </el-table-column>
                    <el-table-column
                    prop="isZhuPaiJiGou"
                    label="是否主查机构"
                    align="center"
                    >
                    <template slot-scope="scope">
                        {{scope.row.isZhuPaiJiGou?"是":"否"}}
                    </template>
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="280px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="materialDetail(scope.row)">查看资料</el-button>
                    </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="任务日志">
                <div style="margin:0 10px;width:100%">
                    
                    <el-table
                        :data="logList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width: 100%">
                        <el-table-column
                        type="index"
                        width="80"
                        label="序号"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="operator"
                        label="操作人"
                        align="center"
                        width="250px"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="content"
                        label="操作内容"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="creationTime"
                        label="操作时间"
                        align="center"
                        width="250px"
                        >
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        
        <!-- <div class="btns" v-if="detailData.taskSate == 20 ||detailData.taskSate == 30">
            <el-button type="primary" icon="el-icon-edit" @click="edit">确认编辑</el-button>
            <el-button type="success" icon="el-icon-edit" @click="examineTask">提交审核</el-button>
        </div> -->
        <!-- <div class="btns" v-if="detailData.auditStatus == 10">
            <el-button type="warning" icon="el-icon-edit" @click="isNoAudit = true">机构审核不通过</el-button>
            <el-button type="success" icon="el-icon-edit" @click="audit(30)">机构审核通过</el-button>
        </div> -->
        <div class="btns" v-if="(detailData.auditStatus == 40 || detailData.auditStatus == 30)" style="margin-top:20px">
            <el-button type="warning" icon="el-icon-edit" @click="isNoAudit = true" v-if="!detailData.qx">总部审核不通过</el-button>
            <el-button type="success" icon="el-icon-edit" @click="audit(60)">总部审核通过</el-button>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDoubtCourse" title="添加" width="800px">
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div class="item">
                    <div class="label">
                        调查时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addDoubtCourse.tCourTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查省级市
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="selectedOptions"
                        @change="handleRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPlace" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查项目
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPro" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourProList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cCourAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourMode" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in CCourModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        被调查人姓名
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cCourOperNme" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        被调查人与被保人关系
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourRela" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourRelaList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查过程
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="addDoubtCourse.cProcess" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
               
            </div>
            <div class="btns">
                <el-button type="primary" icon="el-icon-zoom-in" @click="addDoubtCourseF">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddCaseMaterial" title="添加资料" width="800px">
           
            <div class="item">
                <div class="label">
                    资料名称
                </div>
                <div class="value">
                    <el-input v-model="addCaseMaterial.name" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    单证资料
                </div>
                <div class="value">
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="uploadCPath"
                        >
                        <el-button icon="el-icon-upload2" type="primary" size="small">上传资料</el-button>
                    </el-upload>

                    <el-button type="primary" icon="el-icon-download" size="small" @click="download(addCaseMaterial.path,addCaseMaterial.name)" style="margin-left:20px" v-if="addCaseMaterial.path">下载</el-button>
                </div>
            </div>
               
            <div class="btns">
                <el-button type="primary" icon="el-icon-edit" @click="addCaseMaterialF">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="surveyDataItemDialog" title="调查信息详情" width="800px">
            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="item">
                    <div class="label">
                        调查需求
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="surveyDataItem.cSvyNeed" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        调查需求编码
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyNeedCode" placeholder="请输入" size="small"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        期望完成时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="surveyDataItem.tHopeEndTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        疑案类型
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyType" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyMode" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyPlace" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        创建时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="surveyDataItem.creationTime"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        调查内容
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="assignData.cDoubtOpin" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div> -->
               
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isMechanismDialog" title="选择机构" width="800px">
            <el-table
            ref="multipleTable"
            :data="mechanismList"
            border
            :header-cell-style="tableHeaderColor"
            @selection-change="handleSelectionMechanismChange"
            style="width:100%"
            height="400px"
            >
            <el-table-column
            type="selection"
            align="center"
            width="55">
            </el-table-column>
            <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="机构名称"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="code"
            label="所在地区"
            align="center"
            >
            <template slot-scope="scope">
                {{scope.row.province}}
                {{scope.row.city}}
                {{scope.row.district}}
            </template>

            </el-table-column>
            
            </el-table>
            <div class="footer" style="margin-top:20px">
                <el-button icon="el-icon-circle-close" @click="isMechanismDialog=false">关 闭</el-button>
                <el-button type="primary" @click="affirmMechanism" icon="el-icon-edit-outline">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="userDialog" title="选择人员" width="600px">
            <div class="table">
                <el-table
                    :data="userList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    
                    <el-table-column
                    prop="name"
                    label="用户名称"
                    align="center"
                    >
                    </el-table-column>
                    
                    <el-table-column
                    prop="roleNames"
                    label="关联角色"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" icon="el-icon-circle-check" @click="selectPerson(scope.row)">确认指派</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleCurrentChangeUser"
                        background
                        layout="prev, pager, next, total"
                        :total="userTotalCount"
                        :current-page="userConditionData.page"
                        :page-size="userConditionData.pageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isNoAudit" title="审核不通过" width="800px">
           
            <div class="item">
                <div class="label">
                    不通过原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="taskReason" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="examineTask(50)">确认</el-button>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isNoAuditPerson" title="审核不通过" width="800px">
           
            <div class="item">
                <div class="label">
                    不通过原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="taskReasonPerson" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="examineTaskPerson(20)">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="调查过程"
            :visible.sync="cProcessDetailDialog"
            width="600px"
            :modal="false"
            v-dialogDrag
            >
            <el-input
            placeholder="请输入内容"
            v-model="cProcess"
            type="textarea"
            :rows="20"
            >
            </el-input>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isPersonInfoDialog" title="查看作业人员资料" width="1500px" top="20px">
            <div class="section">
                <div class="title">
                    调查要求
                </div>
                <div class="item">
                    <div class="value" style="width:590px">
                        <el-input v-model="dcyq" placeholder="请输入" size="small" type="textarea" rows="4" disabled></el-input>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div style="margin:0 10px;width:100%">
                    <el-table
                        :data="personDoubtCourseList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                    
                        <el-table-column
                        prop="tCourTm"
                        label="调查时间"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourAddr"
                        label="调查省级市"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourPlace"
                        label="调查地点"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPlace==1">医院</span>
                            <span v-if="scope.row.cCourPlace==2">事故地</span>
                            <span v-if="scope.row.cCourPlace==3">常住地</span>
                            <span v-if="scope.row.cCourPlace==4">住宅</span>
                            <span v-if="scope.row.cCourPlace==5">就诊地</span>
                            <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourPro"
                        label="调查项目"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPro==1">正面调查</span>
                            <span v-if="scope.row.cCourPro==2">基础调查</span>
                            <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                            <span v-if="scope.row.cCourPro==4">事故查勘</span>
                        </template>
                        </el-table-column>
                        
                    
                        <el-table-column
                        prop="cCourMode"
                        label="案件类型"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourMode=='1'">全案</span>
                            <span v-if="scope.row.cCourMode=='2'">单点</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourOperNme"
                        label="被调查人姓名"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourRela"
                        label="被调查人与被保人关系"
                        align="center"
                        width="180px"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourRela=='601002'">子女</span>
                            <span v-if="scope.row.cCourRela=='601003'">父母</span>
                            <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                            <span v-if="scope.row.cCourRela=='601005'">本人</span>
                            <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                            <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                            <span v-if="scope.row.cCourRela=='601008'">其它</span>
                            <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                            <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                            <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                            <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                            <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                            <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                            <span v-if="scope.row.cCourRela=='601016'">未知</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cProcess"
                        label="调查过程"
                        align="center"
                        width="150px"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                        </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="mini" @click="editCCour(scope.row)" >编辑</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="section">
                <div class="title">
                    调查资料
                </div>
                <div style="margin:0 10px;width:100%">
                    <div class="section-item" v-for="(mitem,mindex) in personMaterialList" :key="mindex">
                        <div class="stitle">{{mitem[0].name}}</div>
                        <div class="materiallist">
                            <div class="material" v-for="(item,index) in mitem" :key="index">
                                <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                <el-image
                                style="width: 120px; height: 120px"
                                :src="item.path"
                                v-else
                                @click="showImg(item.path,mitem)"
                                :fit="cover"></el-image>
                                <div class="filename">{{item.fileName}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns" style="margin-top:20px" v-if="detailData.qx">
                <el-button type="primary" icon="el-icon-edit" @click="backPersontask(20)">退回</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isInfoDialog" title="查看资料" width="1500px" top="20px">
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div style="margin:0 10px;width:100%">
                    <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addAllMaterialInfoTip">添加资调查过程</el-button>
                        </div>
                    </div>
                    <el-table
                        :data="otherDoubtCourseList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                    
                        <el-table-column
                        prop="tCourTm"
                        label="调查时间"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourAddr"
                        label="调查省级市"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourPlace"
                        label="调查地点"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPlace==1">医院</span>
                            <span v-if="scope.row.cCourPlace==2">事故地</span>
                            <span v-if="scope.row.cCourPlace==3">常住地</span>
                            <span v-if="scope.row.cCourPlace==4">住宅</span>
                            <span v-if="scope.row.cCourPlace==5">就诊地</span>
                            <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourPro"
                        label="调查项目"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPro==1">正面调查</span>
                            <span v-if="scope.row.cCourPro==2">基础调查</span>
                            <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                            <span v-if="scope.row.cCourPro==4">事故查勘</span>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column
                        prop="cCourAddr"
                        label="调查地址"
                        align="center"
                        >
                        </el-table-column> -->
                    
                        <el-table-column
                        prop="cCourMode"
                        label="案件类型"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourMode=='1'">全案</span>
                            <span v-if="scope.row.cCourMode=='2'">单点</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourOperNme"
                        label="被调查人姓名"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourRela"
                        label="被调查人与被保人关系"
                        align="center"
                        width="180px"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourRela=='601002'">子女</span>
                            <span v-if="scope.row.cCourRela=='601003'">父母</span>
                            <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                            <span v-if="scope.row.cCourRela=='601005'">本人</span>
                            <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                            <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                            <span v-if="scope.row.cCourRela=='601008'">其它</span>
                            <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                            <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                            <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                            <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                            <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                            <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                            <span v-if="scope.row.cCourRela=='601016'">未知</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cProcess"
                        label="调查过程"
                        align="center"
                        width="150px"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                        </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-edit" size="mini" @click="editCCour(scope.row)" >编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourPerson(scope.row)" >删除</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="section">
                <div class="title">
                    调查资料
                </div>
                <div style="margin:0 10px;width:100%">
                    <div class="handle">
                        <div>
                            <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addOtherMaterialDialog">添加资调查过程</el-button>
                        </div>
                    </div>
                    
                    <div class="section-item" v-for="(mitem,mindex) in otherMaterialList" :key="mindex">
                        <div class="stitle">{{mitem[0].name}}</div>
                        <div class="materiallist">
                            <div class="material" v-for="(item,index) in mitem" :key="index">
                                <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                <el-image
                                style="width: 120px; height: 120px"
                                :src="item.path"
                                v-else
                                @click="showImg(item.path,mitem)"
                                :fit="cover"></el-image>
                                <img src="../../../assets/images/icon08.png" class="close" @click="clearOtherMaterial(item)" alt="" >
                                <div class="filename">{{item.fileName}}</div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />


        <el-dialog :close-on-click-modal="false" :visible.sync="isAddAllMaterialDialog" title="添加调查节点" width="800px">
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div class="item">
                    <div class="label">
                        调查人员
                    </div>
                    <div class="value">
                        <el-select v-model="allOperator" size="small" placeholder="请选择" class="citem-input" @change="changeAddDoubtCourseOperator">
                            <el-option
                            v-for="item in personTaskList"
                            :key="item.operatorId"
                            :label="item.operator"
                            :value="item.operatorId">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addDoubtCourse.tCourTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查省级市
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="selectedOptions"
                        @change="handleRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPlace" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查项目
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPro" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourProList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
               
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourMode" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in CCourModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        被调查人姓名
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cCourOperNme" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        被调查人与被保人关系
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourRela" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourRelaList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查过程
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="addDoubtCourse.cProcess" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
               
            </div>
            <div class="btns">
                <el-button type="primary" icon="el-icon-zoom-in" @click="addAllMaterialInfo">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAddOtherMaterialDialog" title="添加资料" width="800px">
            <div class="section">
                
                <div class="item">
                    <div class="label">
                        调查人员
                    </div>
                    <div class="value">
                        <el-select v-model="allOperator" size="small" placeholder="请选择" class="citem-input" @change="changeAddDoubtCourseOperator">
                            <el-option
                            v-for="item in personTaskList"
                            :key="item.operatorId"
                            :label="item.operator"
                            :value="item.operatorId">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                
               <div class="item">
                    <div class="label">
                        资料名称
                    </div>
                    <div class="value">
                        <el-input v-model="addCaseMaterial.name" size="small" placeholder="请输入" style="width:300px"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        单证资料
                    </div>
                    <div class="value" style="width:300px">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="addOtherMaterial"
                            >
                            <el-button icon="el-icon-upload2" type="primary" size="small" :loading="finishNum!=allNum?true:false">上传资料</el-button>
                        </el-upload>
                        <span style="margin-left:10px">
                            完成度：{{finishNum}} / {{allNum}} {{finishNum!=allNum?'请稍等':''}}
                        </span>
                    </div>
                </div>
                <div class="materiallist">
                    <div class="material" v-for="(item,index) in addOtherMaterialList" :key="index">
                        <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                        <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                        <el-image
                        style="width: 120px; height: 120px"
                        :src="item.path"
                        v-else
                        @click="download(item.path,item.name)"
                        :fit="cover"></el-image>
                        <div class="filename">{{item.fileName}}</div>
                    </div>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="addOtherMaterialApi">确认</el-button>
                </div>
            </div>
           
        </el-dialog>
        
    </div>
</template>
<script>
import api from '../../../api/main'
import { regionData , CodeToText } from "element-china-area-data";
import { cCourPlaceList , cCourProList , cCourRelaList , CCourModeList ,RefuseRsnList} from "../../../assets/selectList/anxin";
import { parseTimeS } from "../../../utils/index";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'index',
    components:{
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            uploadUrl:'',
            cCourPlaceList:cCourPlaceList,
            cCourProList:cCourProList,
            cCourRelaList:cCourRelaList,
            CCourModeList:CCourModeList,
            isAssignTask:false,
            detailData:{},
            isAddDoubtCourse:false,
            isAddCaseMaterial:false,
            addDoubtCourse:{},
            addCaseMaterial:{},
            options:regionData,
            selectedOptions:null,
            cConclusionList:[{
                label:'正常赔付',
                value:'1',
            },{
                label:'减损',
                value:'2',
            },{
                label:'拒赔',
                value:'3',
            }],
            auditResultList:[{
                label:'未知',
                value:0,
            },{
                label:'同意',
                value:1,
            },{
                label:'退回',
                value:2,
            }],
            surveyInfo:[],
            surveyData:[],
            detailData:[],
            assignData:{},


            surveyData:[],
            surveyInfo:[],
            surveyDataItem:{},
            surveyDataItemDialog:false,

            mechanismList:[],
            isMechanismDialog:false,
            selectMechanismList:[],

            logList:[],
            stepsActive:0,


            userConditionData:{
                page:1,
                pageSize:10,
            },
            userList:[],
            userDialog:false,
            userTotalCount:0,
            personDetailData:{
                doubtCourseList:[],
            },
            personTaskList:[],


            isNoAudit:false,
            taskReason:'',
            doubTaskMaterialItems:[],
            doubtCourseList:[],

            cProcessDetailDialog:false,
            cProcess:'',
            addCaseMaterialList:[],
            materialList:[],

            surveyDataInfo:{
                anXinDcTaskId:'',
                cConclusion:null,
                cConcRst:'',
                cRefuseRsn:'',
                nRefusePayAmt:null,
                nDeroAmt:null,
            },
            RefuseRsnList:RefuseRsnList,
            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            isPersonInfoDialog:false,
            personDoubtCourseList:[],
            personMaterialList:[],
            dcyq:'',
            isNoAuditPerson:false,
            taskReasonPerson:'',
            // 人员任务id
            personId:'',

            otherJgList:[],
            isInfoDialog:false,
            otherMaterialList:[],
            otherDoubtCourseList:[],
            addOtherMaterialList:[],


            isAddAllMaterialDialog:false,
            // 机构id
            jgRwId:'',
            personTaskList:[],
            allOperatorId:'',
            allOperator:'',
            allDoubtTaskId:'',
            isAddAllZlDialog:false,
            isAddOtherMaterialDialog:false,
            materialIndex:0,

            allNum:0,
            finishNum:0,
        }
    },
    created(){
        

    },
    mounted(){
        this.queryMechanism();
        this.queryDoubtTaskById();
        this.queryUserByMechanismIds();
        this.queryAnXinDcTaskByAnXinDcTaskId();
    },
    methods:{
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        // 查询作业人员列表
        async queryUserByMechanismIds(){
            let res  = await api.queryUserByMechanismIds(this.userConditionData);
            this.userList = res.data.data.data;
            this.userTotalCount = res.data.data.totalCount;
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
         // 机构列表
        async queryMechanism(){
            let res = await api.QueryMechanism();
            this.mechanismList = res.data.data.data;
        },
        changeTab(e){
            if(e.index==0){
                this.queryDoubtTaskById();
            }
            if(e.index==1){
                this.queryAnXinDoubtDetailByAnXinDcTaskId();
            }
            if(e.index==2){
                this.queryAnXinCaseMaterialItemByAnXinDcTaskId();
            }
            if(e.index==3){
                this.queryDoubtTaskItemByDoubtTaskIdd();
            }
            if(e.index==4){
                this.queryDoubtTaskItemByDoubtTaskId();
            }
            if(e.index==5){
                this.queryOtherDoubtTasksByanXinDcTaskId();
            }
            if(e.index==6){
                this.queryAnXinOperationLogByDoubtTaskId();
            }
        },
        // 查看其他机构
        async queryOtherDoubtTasksByanXinDcTaskId(){
            let res = await api.queryOtherDoubtTasksByanXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.otherJgList = res.data.data;
        },
        // 调查结果
        async queryDoubtTaskItemByDoubtTaskIdd(){
            let res = await api.queryDoubtTaskItemByDoubtTaskIdd(this.$route.query.id);
            console.log(res);
            this.doubTaskMaterialItems = res.data.data.doubTaskMaterialItems;
            this.doubtCourseList = res.data.data.doubtCourseList;
            let name = '';
            this.materialList = [];
            for(let i in this.doubTaskMaterialItems){
                if(name!=this.doubTaskMaterialItems[i].name){
                    name = this.doubTaskMaterialItems[i].name;
                    this.materialList.push([]);
                }
                this.materialList[this.materialList.length-1].push(this.doubTaskMaterialItems[i]);
            }
        },
        // 调查任务Id查询调查资料
        async queryAnXinCaseMaterialItemByAnXinDcTaskId(){
            let res = await api.queryAnXinCaseMaterialItemByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.surveyInfo = res.data.data;
        },
        // 调查任务Id查询调查信息
        async queryAnXinDoubtDetailByAnXinDcTaskId(){
            let res = await api.queryAnXinDoubtDetailByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.surveyData = res.data.data;
        },
        async queryDoubtTaskItemByDoubtTaskId(){
            let res = await api.queryDoubtTaskItemByDoubtTaskId(this.$route.query.id);
            this.personTaskList = res.data.data;
        },
        // 作业机构
        async queryDoubtTasksByAnXinDcTaskId(){
            let res = await api.queryDoubtTasksByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.detailData=res.data.data;
            if(!this.detailData.doubTaskMaterialItems){
                this.detailData.doubTaskMaterialItems = [];
            }
            if(!this.detailData.doubtCourseList){
                this.detailData.doubtCourseList = [];
            }
        },
        // 日志
        async queryAnXinOperationLogByDoubtTaskId(){
            let res = await api.queryAnXinOperationLogByDoubtTaskId(this.$route.query.id);
            this.logList=res.data.data;
        },
        // 调查信息详情
        surveyDataDetail(row){
            console.log(row);
            this.surveyDataItemDialog = true;
            this.surveyDataItem = row;
        },
        // 指派作业机构
        assignJobAgencies(){
            console.log(this.isMechanismDialog);
            console.log(this.mechanismList);
            this.isMechanismDialog=true
        },
        // 指派机构
        async affirmMechanism(){
            console.log(this.selectMechanismList);
            console.log(this.detailData);
            let option = [];
            for(let i in this.selectMechanismList){
                
                option.push({
                    anXinDcTaskId:this.detailData.id,
                    cDoubtId:this.detailData.cDoubtId,
                    operatorMechanism:this.selectMechanismList[i].name,
                    operatorMechanismId:this.selectMechanismList[i].id,
                    CClmNo:this.detailData.cClmNo,
                    CPlyNo:this.detailData.cPlyNo,
                    CInsuredNme:this.detailData.cInsuredNme,
                })
                
            }
            let res = await api.batchDispatchTaskToOperatorMechanism({
                AnXinDcTaskId:this.detailData.id,
                doubtTaskRequest:option
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '指派成功!'
                });
                this.isMechanismDialog=false;
                this.queryDoubtTasksByAnXinDcTaskId(this.detailData.id);
            }
        },
        // 选择机构
        handleSelectionMechanismChange(e){
            this.selectMechanismList = e;
        },
        // 取消指派
        async cancelAssign(row){
            this.$confirm('将取消指派，是否确认?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteDoubtTaskItem(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async deleteDoubtTaskItem(id){
            let res = await api.deleteDoubtTaskItem(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '已取消成功'
                });  
                this.queryDoubtTaskItemByDoubtTaskId();
            }
        },
        // 接受任务
        receiveDoubtTaskTip(){
            this.$confirm('确认接受任务, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.receiveDoubtTask();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async receiveDoubtTask(){
            let res = await api.receiveDoubtTask({
                id:this.$route.query.id
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '接受成功'
                });  
                this.queryDoubtTasksByAnXinDcTaskId();
            }
        },
        // 设为主派机构
        async setZhuPaiMechanismTip(row){
            console.log(row);
            this.$confirm('设置为主派机构, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.setZhuPaiMechanism(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async setZhuPaiMechanism(row){
            let res = await api.setZhuPaiMechanism({
                anXinDcTaskId: row.anXinDcTaskId,
                zpMechanismId: row.operatorMechanismId,
                zpMechanismName: row.operatorMechanism
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '设置成功'
                });  
                this.queryDoubtTasksByAnXinDcTaskId();
            }
        },
        assignPersonTip(){
            this.taskData = this.detailData;
            this.userDialog = true;
        },

        async selectPerson(row){
            this.taskData.operatorId = row.id;
            this.taskData.operator = row.name;
            this.taskData.doubtTaskId = this.$route.query.id;
            let res = await api.assignTaskToOperator(this.taskData);
            if(res.data.code == '200') {
                this.$message({
                    message: '指派成功',
                    type: 'success'
                });
                this.userDialog = false;
                this.queryDoubtTaskItemByDoubtTaskId();
            }
        },
        
       

        handleCurrentChangeUser(page){
            this.userConditionData.page = page;
            this.queryUserByMechanismIds();
        },


        // 调查过程
        doubtCourseAddTip(){
            this.isAddDoubtCourse = true;
        },
        // 添加调查节点成功
        async addDoubtCourseF(){
            this.addDoubtCourse.tCourTm = parseTimeS(this.addDoubtCourse.tCourTm)

            
            this.detailData.doubtCourseList.push(this.addDoubtCourse);
            this.$forceUpdate(); 
            this.isAddDoubtCourse = false;
        },
        deleteCCourTip(scope){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteCCour(scope.$index);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        deleteCCour(index){
            this.detailData.doubtCourseList.splice(index,1);
            this.$message({
                type: 'success',
                message: '已删除成功'
            });    
        },
        // 调查任务Id查询调查信息
        async queryDoubtTaskById(){
            let res = await api.queryDoubtTaskById(this.$route.query.id);
            this.detailData = res.data.data;
            this.detailData.doubtCourseList = this.detailData.doubtCourseList?this.detailData.doubtCourseList:[]
            this.detailData.doubTaskMaterialItems = this.detailData.doubTaskMaterialItems?this.detailData.doubTaskMaterialItems:[]
           
            if(this.detailData.executeAction==0){
                this.stepsActive = 0;
            }
            if(this.detailData.executeAction==10){
                this.stepsActive = 1;
            }
            if(this.detailData.executeAction==20){
                this.stepsActive = 2;
            }
            if(this.detailData.executeAction>=25){
                this.stepsActive = 3;
            }
            
        },
        // 确认编辑
        async edit(){
            this.detailData.nRefusePayAmt = parseFloat(this.detailData.nRefusePayAmt);
            this.detailData.nDeroAmt = parseFloat(this.detailData.nDeroAmt);
            let res = await api.updateTaskInfo(this.detailData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
            }
        },
        audit(status){
            if(status){
                this.$confirm('再次确认是否通过?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.examineTask(status);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消退出'
                    });          
                });
            }
        },
        // 审核机构
        async examineTask(taskSate){
           let option = {
                id:this.$route.query.id,
                auditStatus:taskSate,
                taskReason:this.taskReason,
            };
            
            let res  = await api.updateAuditStatusDoubtTask(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                this.isNoAudit = false;
                this.queryDoubtTaskById();
            }
        },
        backPersontask(status){
            this.isNoAuditPerson = true;
            // this.$confirm('再次确认是否退回?', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.examineTaskPerson(status);
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消退出'
            //     });          
            // });
        },
        // 审核人员
        async examineTaskPerson(auditStatus){
            let option = {
                id:this.personId,
                auditStatus:auditStatus,
                taskReason:this.taskReasonPerson
            };
            
            let res  = await api.updateAuditStatus(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                this.isNoAuditPerson = false;
                this.isPersonInfoDialog = false;

                this.queryDoubtTaskItemByDoubtTaskId();
            }
        },
         handleRegionChange(){
            let e = this.selectedOptions;
            
                if(e[2]){
                    this.addDoubtCourse.cCourAddr = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]+'-'+CodeToText[e[0],e[1],e[2]]
                }else if(e[1]){
                    this.addDoubtCourse.cCourAddr = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]
                }
                this.addDoubtCourse.cCourAll=this.selectedOptions;
                for(let index in this.selectedOptions){
                    this.addDoubtCourse.cCourAll[index] = parseInt(this.selectedOptions[index]);
                }
            console.log(this.addDoubtCourse);
        },
        // 上传
        async uploadCPath(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            this.addCaseMaterial.fileType = fileType;
            let res = await api.uploadOther(file.file);
            this.addCaseMaterial.path = res;
            this.$forceUpdate();
            console.log(res);

        },
        // 添加调查资产
        addCaseMaterialF(){
            this.detailData.doubTaskMaterialItems.push(this.addCaseMaterial);
            this.isAddCaseMaterial = false;
            console.log(this.detailData.doubTaskMaterialItems);
            this.$forceUpdate();
        },
        // 下载资料
        download(path,name){
            this.$message({
                type: 'success',
                message: '下载成功,请稍等!'
            });
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        deleteDoubTaskMaterialItemTip(scope){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteCCour(scope.$index);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        deleteDoubTaskMaterialItem(index){
            this.detailData.doubTaskMaterialItems.splice(index,1);
            this.$message({
                type: 'success',
                message: '已删除成功'
            });   
        },
        async cProcessDetail(detail){
            console.log(detail);
            this.cProcess = detail;
            this.cProcessDetailDialog = true;
        },

        // 查询调查信息
        async queryAnXinDcTaskByAnXinDcTaskId(){
            let res = await api.queryAnXinDcTaskByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            console.log(res);
            this.surveyDataInfo=res.data.data
        },
        // 编辑调查结论
        async updateCccnn(){
            let res = await api.UpdateCccnn({
                anXinDcTaskId:this.$route.query.anXinDcTaskId,
                cConclusion:this.surveyDataInfo.cConclusion,
                cConcRst:this.surveyDataInfo.cConcRst,
                cRefuseRsn:this.surveyDataInfo.cRefuseRsn,
                nRefusePayAmt:parseFloat(this.surveyDataInfo.nRefusePayAmt?this.surveyDataInfo.nRefusePayAmt:0),
                nDeroAmt:parseFloat(this.surveyDataInfo.nDeroAmt?this.surveyDataInfo.nDeroAmt:0),
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
            }
                    
        },
        // 人员
        async personDetail(row){
            this.isPersonInfoDialog = true;
            let res = await api.queryDoubtTaskItemById(row.id);
            let doubTaskMaterialItems = res.data.data.doubTaskMaterialItems;
            this.personDoubtCourseList = res.data.data.doubtCourseList;
            this.dcyq = res.data.data.dcyq;
            this.personId = res.data.data.id;
            let name = '';
            this.personMaterialList = [];
            for(let i in doubTaskMaterialItems){
                if(name!=doubTaskMaterialItems[i].name){
                    name = doubTaskMaterialItems[i].name;
                    this.personMaterialList.push([]);
                }
                this.personMaterialList[this.personMaterialList.length-1].push(doubTaskMaterialItems[i]);
            }
        },

        // 查看过程
        editCCour(row){
            console.log(row);
            localStorage.setItem('CCour',JSON.stringify(row));
           
            const { href } = this.$router.resolve({
                name: "doubtCourseDetail",
            });
            window.open(href, '_blank');
        },
        // 删除调查过程
        deleteCCourPerson(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCCourApi(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteCCourApi(row){
            let res = await api.deleteDoubtCourseList({
                id:row.id,
                doubtTaskItemId:row.doubtTaskItemId,
            });
            if(res.data.code='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
                this.materialDetail();

            }
           
        },
        // 其他机构人员
        async materialDetail(row){
            this.isInfoDialog = true;
            this.jgRwId = row?row.id:this.jgRwId;
            let res = await api.queryDoubtTaskItemByDoubtTaskIdd(this.jgRwId);
            let doubTaskMaterialItems = res.data.data.doubTaskMaterialItems;
            this.otherDoubtCourseList = res.data.data.doubtCourseList;
            let name = '';
            this.otherMaterialList = [];
            for(let i in doubTaskMaterialItems){
                if(name!=doubTaskMaterialItems[i].name){
                    name = doubTaskMaterialItems[i].name;
                    this.otherMaterialList.push([]);
                }
                this.otherMaterialList[this.otherMaterialList.length-1].push(doubTaskMaterialItems[i]);
            }
        },
        // 新增调查过程
        async addAllMaterialInfoTip(){
            this.isAddAllMaterialDialog = true;
            let res = await api.queryOperatorByDoubtTaskId(this.jgRwId);
            this.personTaskList = res.data.data;
        },
        // 选择调查人员
        changeAddDoubtCourseOperator(e){
            for(let index in this.personTaskList){
                if(e == this.personTaskList[index].operatorId){
                    this.allOperatorId = e;
                    this.allOperator = this.personTaskList[index].operator;
                }
            }
        },
        // 新增调查过程接口
        async addAllMaterialInfo(){
            let res = await api.addDoubtCourseList({
                operatorId:this.allOperatorId,
                operator:this.allOperator,
                doubtTaskId:this.jgRwId,
                doubtCourseList:this.addDoubtCourse
                
            });
            if(res.data.code='200'){
                this.isAddAllMaterialDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });     
                this.materialDetail();
            }
        },

        // 添加其他资料
        async addOtherMaterial(file){
            if(!this.addCaseMaterial.name){
                this.$message({
                    type: 'warning',
                    message: '请先填写资料名称!'
                });
                return;
            }
            this.allNum = this.allNum+1;
            let name = this.addCaseMaterial.name;
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            let res = await api.uploadOther(file.file);
            let path = res;
            this.addOtherMaterialList.push({
                fileType:fileType,
                fileName:file.file.name,
                name:name,
                path:path,
            });
            this.finishNum = this.finishNum+1;
            console.log(this.addOtherMaterialList);
            this.$forceUpdate();
        },

        async addOtherMaterialApi(){
            let res = await api.addDoubTaskMaterialItems({
                operatorId:this.allOperatorId,
                operator:this.allOperator,
                doubtTaskId:this.jgRwId,
                doubTaskMaterialItems:this.addOtherMaterialList
            });
            if(res.data.code='200'){
                this.isAddOtherMaterialDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功'
                });     
                this.finishNum=0;
                this.allNum=0;
                this.addOtherMaterialList = [];
                this.materialDetail();
            }

        },

        async addOtherMaterialDialog(){
            this.isAddOtherMaterialDialog = true;
            let res = await api.queryOperatorByDoubtTaskId(this.jgRwId);
            this.personTaskList = res.data.data;

        },

        async clearOtherMaterial(item){
            this.$confirm('确认删除资料, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.clearOtherMaterialApi(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async clearOtherMaterialApi(item){
            let res = await api.deleteDoubTaskMaterialItems({
                doubtTaskItemId:item.doubtTaskItemId,
                id:item.id,
            });
            if(res.data.code='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });     
                this.materialDetail();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner{
        color:#606266;
    }
    .top{
        display: flex;
        justify-content: space-between;
        padding:10px;
        background-color: #ffffff;
    }
    .handle{
        margin-bottom: 10px;
    }
    .section{
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 15px;
        padding-bottom: 10px;
        .title{
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            background-color: #DEDEDE;
            padding:8px 15px;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 120px;
            }
            .value{
                width: 220px;
            }
            .piclist{
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding:10px 15px;
                .label{
                    width: 230px;
                    font-size: 14px;
                }
                .pics{
                    display: flex;
                    flex-wrap: wrap;
                    .pics-item{
                        width: 100px;
                        height: 100px;
                        position: relative;
                        margin: 15px;
                        .img{
                            width: 100px;
                            height: 100px;
                        }
                        .close{
                            position: absolute;
                            top: -12px;
                            right: -12px;
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .uploadbtn{
                    border: 1px solid #dcdcdc;
                    width: 106px;
                    height: 106px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 15px;
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
                
            }
        }
    
    }
    .item{
        font-size: 14px;
        padding:10px 15px;
        display: flex;
        align-items: center;
        .label{
            margin-bottom: 5px;
            width: 120px;
        }
        .value{
            width: 220px;
            display: flex;
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 100px;
                    height: 100px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 100px;
                        height: 100px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
            
        }
    }
    .btns{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .taskreason{
        span{
            color: red;
            font-size: 18px;
        }
        font-size: 14px;
        margin: 10px 0;
    }
    .materiallist{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 15px;
        width: 100%;
        .material{
            border: 1px dashed #dcdcdc;
            width: 150px;
            height: 170px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            margin:10px;
            position: relative;
            img{
                width: 120px;
            }
            .close{
                width: 25px;
                height: 25px;
                position: absolute;
                right: 3px;
                top: 3px;
            }
            .filename{
                width: 130px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                margin-top: 2px;
            }
        }
    }
    .section-item{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 10px;
        .stitle{
            background-color: #f1f1f1;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            border-bottom:1px solid #DEDEDE;
            padding:8px 15px;
        }
        
    }
    /deep/.el-step.is-simple .el-step__title{
        font-size: 14px;
    } 
    /deep/.el-steps--simple{
        padding:  0px;
        background-color: #ffffff;
    }
    /deep/.el-steps{
        width: 1000px;
    }
    /deep/.el-step.is-simple .el-step__arrow::after, /deep/.el-step.is-simple .el-step__arrow::before{
        height: 9px !important;
    }
    
    /deep/.el-step.is-simple .el-step__arrow::after{
        transform: rotate(45deg) translateY(3px);
    }
    /deep/.el-step.is-simple .el-step__arrow::before{
        transform: rotate(-45deg) translateY(-3px);
    }
</style>
